import React from 'react'

export default function GeneralError({ children }) {
  return <div>{children}</div>
}
